import { ReactNode } from 'react';

export const Caption = ({ children }: { children: ReactNode }) =>
  children ? (
    <span className="mb-6 text-iron body-12-medium">{children}</span>
  ) : null;
